"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RugbyLeaguePeriodName;
(function (RugbyLeaguePeriodName) {
    RugbyLeaguePeriodName["pregame"] = "Pre Game";
    RugbyLeaguePeriodName["regularFirstHalf"] = "First Half";
    RugbyLeaguePeriodName["regularHalfTime"] = "Half Time";
    RugbyLeaguePeriodName["regularSecondHalf"] = "Second Half";
    RugbyLeaguePeriodName["regularTimeFinished"] = "Regular Time";
    RugbyLeaguePeriodName["goldenPointFirstHalf"] = "Golden Point - 1st Half";
    RugbyLeaguePeriodName["goldenPointHalfTime"] = "Golden Point - Break";
    RugbyLeaguePeriodName["goldenPointSecondHalf"] = "Golden Point - 2nd Half";
    RugbyLeaguePeriodName["matchFinishedGP"] = "Full Time - Golden Point";
    RugbyLeaguePeriodName["matchFinishedReg"] = "Full Time";
    RugbyLeaguePeriodName["matchCancelled"] = "Match Cancelled";
})(RugbyLeaguePeriodName = exports.RugbyLeaguePeriodName || (exports.RugbyLeaguePeriodName = {}));
var RugbyLeaguePeriodShortName;
(function (RugbyLeaguePeriodShortName) {
    RugbyLeaguePeriodShortName["pregame"] = "Pre Game";
    RugbyLeaguePeriodShortName["regularFirstHalf"] = "1st Half";
    RugbyLeaguePeriodShortName["regularHalfTime"] = "Half Time";
    RugbyLeaguePeriodShortName["regularSecondHalf"] = "2nd Half";
    RugbyLeaguePeriodShortName["regularTimeFinished"] = "Regular Time";
    RugbyLeaguePeriodShortName["goldenPointFirstHalf"] = "GP - 1st";
    RugbyLeaguePeriodShortName["goldenPointHalfTime"] = "GP - Break";
    RugbyLeaguePeriodShortName["goldenPointSecondHalf"] = "GP - 2nd";
    RugbyLeaguePeriodShortName["matchFinishedGP"] = "Full Time - GP";
    RugbyLeaguePeriodShortName["matchFinishedReg"] = "Full Time";
    RugbyLeaguePeriodShortName["matchCancelled"] = "Cancelled";
})(RugbyLeaguePeriodShortName = exports.RugbyLeaguePeriodShortName || (exports.RugbyLeaguePeriodShortName = {}));
var RugbyLeaguePeriodCode;
(function (RugbyLeaguePeriodCode) {
    RugbyLeaguePeriodCode["pregame"] = "pregame";
    RugbyLeaguePeriodCode["regularFirstHalf"] = "firstHalf";
    RugbyLeaguePeriodCode["regularHalfTime"] = "halfTime";
    RugbyLeaguePeriodCode["regularSecondHalf"] = "secondHalf";
    RugbyLeaguePeriodCode["regularTimeFinished"] = "regularTimeFinished";
    RugbyLeaguePeriodCode["goldenPointFirstHalf"] = "goldenPointFirstHalf";
    RugbyLeaguePeriodCode["goldenPointHalfTime"] = "goldenPointHalfTime";
    RugbyLeaguePeriodCode["goldenPointSecondHalf"] = "goldenPointSecondHalf";
    RugbyLeaguePeriodCode["matchFinishedGP"] = "matchFinishedGP";
    RugbyLeaguePeriodCode["matchFinishedReg"] = "matchFinishedReg";
    RugbyLeaguePeriodCode["matchCancelled"] = "matchCancelled";
})(RugbyLeaguePeriodCode = exports.RugbyLeaguePeriodCode || (exports.RugbyLeaguePeriodCode = {}));
//# sourceMappingURL=Periods.js.map